<template>
<div>
    <crud-table :actions="actions" no-pagination :titleIcon="titleIcon" hide-create :title="title" :items="purchasesItemsComputed" :headers="headers">
        <template slot="header-actions">
            <div class="me-lg-3">
                <slot name="header-actions" />
            </div>
            <v-btn v-if="allHref" color="primary" depressed :to="allHref" :disabled="!purchasesItems || purchasesItems.length === 0">
                <v-icon size="20" left>mdi-order-bool-descending-variant</v-icon>
                <span>عرض كل عمليات الشراء</span>
            </v-btn>
        </template>
    </crud-table>
</div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import CrudTable from '@/components/default/crud-table'

export default {
    props: {
        purchases: {},
        title: {default: 'عمليات الشراء'},
        titleIcon: {},
        allHref: {},
    },
    components: {CrudTable},
    data(){
        return {
            purchasesItems: null,
            headers: [
                /* {
                    text: 'عمليات',
                    value: 'actions',
                    sortable: false
                }, */
                {
                    text: '#',
                    align: 'center',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'اسم الطالب',
                    align: 'center',
                    sortable: false,
                    value: 'userName',
                },
                {
                    text: 'نوع العنصر',
                    align: 'center',
                    sortable: false,
                    value: 'purchasable_type',

                    chip: true,
                    chipFunction: (method)=>{
                        if (method === 'App\\Lecture'){
                            return {text: 'محاضرة', color: 'blue darken-4', icon: 'mdi-clipboard-play-outline', filled: true,}
                        }else if (method === 'App\\Course'){
                            return {text: 'دورة', color: 'orange darken-2', icon: 'mdi-play-box-outline', filled: true,}
                        }
                    },
                },
                {
                    text: 'العنصر',
                    align: 'center',
                    sortable: false,
                    value: 'purchasableName',
                    button: 'purchasableUrl',
                    color: 'link'
                },
                {
                    text: 'طريقة الدفع',
                    align: 'center',
                    sortable: false,
                    value: 'purchase_method',

                    chip: true,
                    chipFunction: (method)=>{
                        if (method === 'admin'){
                            return {text: 'اﻹدارة', color: 'indigo', icon: 'mdi-briefcase-account-outline'}
                        }else if (method === 'teacher'){
                            return {text: 'المعلم', color: 'indigo', icon: 'mdi-account-tie-outline'}
                        }else if (method === 'systemApi'){
                            return {text: 'System API', color: 'black', icon: 'mdi-server-network-outline'}
                        }else if (method === 'payCard'){
                            return {text: 'بطاقة دفع', color: 'success', icon: 'mdi-credit-card-outline'}
                        }else if (method === 'wallet'){
                            return {text: 'الدفع بالمحفظة', color: 'orange darken-2', icon: 'mdi-wallet-outline'}
                        }else if (method === 'free'){
                            return {text: 'عنصر مجاني', color: 'deep-purple accent-4', icon: 'mdi-star-four-points-outline'}
                        }
                    },
                },
                {
                    text: 'بطاقة الدفع',
                    align: 'center',
                    sortable: false,
                    value: 'payCardSerial',
                    button: 'payCardUrl',
                    color: 'link'
                },
                /* {
                    text: 'الحالة',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                }, */

                {
                    text: 'تاريخ العملية',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        ...GlobalComputed,

        purchasesItemsComputed(){
            return this.purchasesItems.map(purchase=>{
                const method = purchase.purchase_method === 'admin' ? 'اﻹدارة' : (purchase.purchase_method === 'payCard' ? 'بطاقة دفع' : (purchase.purchase_method === 'free' ? 'مجاناً' : (purchase.purchase_method === 'wallet' ? 'دفع بالمحفظة' : purchase.purchase_method)))
                const purchasableName = purchase.purchasable ? (purchase.purchasable_type === 'App\\Lecture' ? purchase.purchasable.full_name : (purchase.purchasable.name ? purchase.purchasable.name : purchase.purchasable )) : null;
                const purchasableUrl = purchase.purchasable ? (purchase.purchasable_type === 'App\\Lecture' ? `/lectures/${purchase.purchasable.id}` : (purchase.purchasable_type === 'App\\Course' ? `/courses/${purchase.purchasable.id}` : null)) : null;
                return {
                    ...purchase,
                    method,
                    userName: purchase.user ? purchase.user.name : '',
                    payCardSerial: purchase.payCard ? purchase.payCard.serial + '#' : '___',
                    payCardUrl: purchase.payCard ? `/paycards?query=${purchase.payCard.serial}` : null,
                    purchasableName,
                    purchasableUrl,

                }
            });
        },
        actions(){
            let actions = [
                // {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
                // {name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'},
            ];
            return actions;
        },
    },
    watch: {
        purchases(purchases){
            this.purchasesItems = purchases.data;
        },
    },
    methods: {
        ...GlobalMethods,


        syncItem(newItem){
            this.purchasesItems = this.purchasesItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.purchasesItems = this.purchasesItems.filter(item=>{
                return item.id !== id;
            })
        },
    },
    created(){
        this.purchasesItems = this.purchases.data;
    }
}
</script>

<style>

</style>
